import { API_ENDPOINT_ACCREDITED_INVESTOR_STATUSES } from '../config'
import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'
import { buildUrl } from '../utils/helpers'

export const ACCREDITATION_STATUSES_REQUEST = 'ACCREDITATION_STATUSES_REQUEST'
export const ACCREDITATION_STATUSES_SUCCESS = 'ACCREDITATION_STATUSES_SUCCESS'
export const ACCREDITATION_STATUSES_FAILURE = 'ACCREDITATION_STATUSES_FAILURE'

const buildDataUrl = (page = 1, limit = 25, filter = {}, sortData) => {
  let queryParams = {}

  if (page && limit) {
    const offset = (page - 1) * limit
    queryParams = { ...queryParams, ...{ page, limit, offset } }
  }

  if (filter) {
    const { status, search } = filter
    if (status && status !== 'All') {
      queryParams = { ...queryParams, ...{ status } }
    }

    if (search) {
      queryParams = { ...queryParams, ...{ search } }
    }
  }

  if (sortData) {
    const { field, order } = sortData
    if (field && order) {
      const ordering = order === 'asc' ? field : `-${field}`
      queryParams = { ...queryParams, ...{ ordering } }
    }
  }

  return buildUrl(`${API_ENDPOINT_ACCREDITED_INVESTOR_STATUSES}/`, {
    ...queryParams,
  })
}

/**
 * requests accreditation status
 * @param page Integer page number
 * @param limit Integer page limit
 * @param filter Object filter
 * @param sortData SortData sorting object
 * @return {{}}
 */
export const fetchAccreditationStatuses = (page = 1, limit = 10, filter = {}, sortData) => ({
  [CALL_API]: {
    endpoint: buildDataUrl(page, limit, filter, sortData),
    types: [ACCREDITATION_STATUSES_REQUEST, ACCREDITATION_STATUSES_SUCCESS, ACCREDITATION_STATUSES_FAILURE],
    method: 'GET',
    tokenType: API_JWT_TOKEN_NAME,
  },
})
